import { FC } from 'react'
import { Box, Typography, useTheme } from '@mui/material'
import { alpha } from '@mui/material/styles'
import { useIntl } from 'react-intl'
import dayjs from 'dayjs'
import {
  FAULT_TIMELINE_STEPS,
  getFaultTimelineActiveIndex
} from 'components/Helpdesk/helpdesk.utils'

interface FaultTimelineProps {
  statusCode: string
  createdAt: string
}

// Vertical status history for a fault ticket (Figma "Historia statusów").
const FaultTimeline: FC<FaultTimelineProps> = ({ statusCode, createdAt }) => {
  const theme = useTheme()
  const { formatMessage } = useIntl()
  const activeIndex = getFaultTimelineActiveIndex(statusCode)

  return (
    <Box>
      {FAULT_TIMELINE_STEPS.map(({ code, i18n }, index) => {
        const isReached = index <= activeIndex
        const isLast = index === FAULT_TIMELINE_STEPS.length - 1
        return (
          <Box key={code} sx={{ display: 'flex', gap: '14px', minHeight: '48px' }}>
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '20px' }}>
              <Box
                sx={{
                  width: '12px',
                  height: '12px',
                  borderRadius: '6px',
                  mt: '2px',
                  flexShrink: 0,
                  backgroundColor: isReached ? theme.r4r.navy : 'transparent',
                  border: isReached ? 'none' : `2px solid ${theme.r4r.greyLight}`
                }}
              />
              {!isLast && (
                <Box
                  sx={{
                    width: '2px',
                    flex: 1,
                    my: '4px',
                    backgroundColor: isReached ? alpha(theme.r4r.navy, 0.25) : theme.r4r.greyLight
                  }}
                />
              )}
            </Box>
            <Box sx={{ pb: '12px' }}>
              <Typography
                sx={{
                  fontSize: '13px',
                  fontWeight: isReached ? 600 : 400,
                  color: isReached ? theme.r4r.ink : theme.r4r.grey,
                  lineHeight: 'normal'
                }}>
                {formatMessage(i18n)}
              </Typography>
              <Typography sx={{ fontSize: '11px', color: theme.r4r.grey, mt: '2px' }}>
                {index === 0 ? dayjs(createdAt).format('DD.MM.YYYY, HH:mm') : '—'}
              </Typography>
            </Box>
          </Box>
        )
      })}
    </Box>
  )
}

export default FaultTimeline
